import { render, staticRenderFns } from "./CouponBadge.vue?vue&type=template&id=ee2dff58&scoped=true&"
import script from "./CouponBadge.vue?vue&type=script&lang=js&"
export * from "./CouponBadge.vue?vue&type=script&lang=js&"
import style0 from "./CouponBadge.vue?vue&type=style&index=0&id=ee2dff58&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee2dff58",
  null
  
)

export default component.exports